import { createStorageBase } from '@/core/utils/localStorage';
export const sharedSessionStorage = createStorageBase('session');
